var _g, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostBreakdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 122,
    viewBox: "0 0 328 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 62,
    r: 60,
    fill: "#F8BC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5 62C170.5 47.5307 165.271 33.5487 155.777 22.6299C146.283 11.7111 133.162 4.5911 118.833 2.5815C104.504 0.571905 89.9314 3.80812 77.7998 11.694C65.6682 19.5798 56.795 31.584 52.8147 45.4951C48.8345 59.4063 50.0154 74.2872 56.1399 87.3964C62.2644 100.506 72.9199 110.96 86.1434 116.834C99.3669 122.708 114.268 123.605 128.1 119.36C141.933 115.116 153.766 106.016 161.42 93.7363L110.5 62H170.5Z",
    fill: "#FF7557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5 62C170.5 48.3196 165.825 35.05 157.25 24.3907C148.675 13.7314 136.714 6.32267 123.351 3.39247C109.988 0.462274 96.0254 2.18662 83.7768 8.27968C71.5283 14.3727 61.7296 24.4686 56.0053 36.8938C50.2809 49.3189 48.9745 63.3272 52.3026 76.5966C55.6307 89.866 63.3935 101.6 74.3042 109.853C85.2149 118.105 98.6183 122.382 112.293 121.973C125.967 121.564 139.091 116.495 149.489 107.605L110.5 62H170.5Z",
    fill: "#72BEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5 62C170.5 52.1329 168.067 42.4182 163.415 33.7162C158.764 25.0142 152.038 17.5937 143.834 12.1118C135.63 6.62998 126.201 3.25606 116.381 2.28892C106.561 1.32178 96.655 2.79127 87.539 6.56723C78.423 10.3432 70.379 16.3091 64.1194 23.9364C57.8598 31.5637 53.5779 40.6171 51.6529 50.2946C49.7279 59.972 50.2193 69.9749 53.0836 79.4171C55.9478 88.8593 61.0965 97.4493 68.0736 104.426L110.5 62H170.5Z",
    fill: "#5BB7AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5 62C170.5 48.656 166.052 35.6928 157.859 25.1602C149.665 14.6277 138.195 7.12694 125.261 3.84408L110.5 62H170.5Z",
    fill: "#CA80DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 62C173.5 47.9888 168.829 34.3774 160.226 23.3183C151.624 12.2591 139.58 4.38329 125.999 0.936286L110.5 62H173.5Z",
    fill: "#9575CD",
    fillOpacity: 0.6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 186.5,
    y: 21,
    width: 91,
    height: 10,
    rx: 4,
    fill: "black",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 186.5,
    y: 39,
    width: 46,
    height: 10,
    rx: 4,
    fill: "black",
    fillOpacity: 0.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 186.5,
    y: 57,
    width: 66,
    height: 10,
    rx: 4,
    fill: "black",
    fillOpacity: 0.04
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 186.5,
    y: 75,
    width: 56,
    height: 10,
    rx: 4,
    fill: "black",
    fillOpacity: 0.04
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 186.5,
    y: 93,
    width: 66,
    height: 10,
    rx: 4,
    fill: "black",
    fillOpacity: 0.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostBreakdown);
export default __webpack_public_path__ + "static/media/cost_breakdown.df1b8b19f86c2c6a62f11eb77e75291c.svg";
export { ForwardRef as ReactComponent };